module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tabs.length > 1) ? _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "top-tabs"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }), _vm._v(" "), _c('el-tabs', {
    key: _vm.reload,
    attrs: {
      "type": "border-card",
      "closable": ""
    },
    on: {
      "tab-remove": _vm.handleTabClose
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(item) {
    return _c('el-tab-pane', {
      key: item.id,
      attrs: {
        "label": item.title,
        "name": item.id + '',
        "id": item.id,
        "link": item.link
      }
    })
  }), 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d600bce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/MainTopTabs.vue
// module id = 671
// module chunks = 1